import Immutable from 'seamless-immutable';
import { handleActions } from 'redux-actions';
import * as actionTypes from '$constants/action-types';

const defaultState = Immutable({
  signup: {},
  login: {},
  recover: {},
  resetPassword: {},
  agentUpdate: {}
});

const reducer = {
  [actionTypes.accounts.CREATE_FAILURE](state, action) {
    return state.setIn(['signup', 'errors'], action.errors);
  },

  [actionTypes.accounts.LOGIN_FAILURE](state, action) {
    return state.setIn(['login', 'errors'], action.errors);
  },

  [actionTypes.accounts.RECOVER_FAILURE](state, action) {
    return state.setIn(['recover', 'errors'], action.errors);
  },

  [actionTypes.accounts.RESET_PASSWORD](state, action) {
    return state.setIn(['resetPassword', 'errors'], action.errors);
  },

  [actionTypes.accounts.RESET_PASSWORD_FAILURE](state, action) {
    return state.setIn(['resetPassword', 'errors'], action.errors);
  },

  [actionTypes.agents.UPDATE_FAILURE](state, action) {
    return state.setIn(['agentUpdate', 'errors'], action.errors)
                .setIn(['agentUpdate', 'success'], false);
  },

  [actionTypes.agents.UPDATE_SUCCESS](state, action) {
    return state.setIn(['agentUpdate', 'errors'], null)
                .setIn(['agentUpdate', 'success'], true);
  },

  [actionTypes.router.CHANGE](state) {
    return state.setIn(['signup', 'errors'], null)
                .setIn(['login', 'errors'], null)
                .setIn(['recover', 'errors'], null)
                .setIn(['resetPassword', 'errors'], null)
                .setIn(['agentUpdate', 'errors'], null)
                .setIn(['agentUpdate', 'success'], null);
  }
}

export default handleActions(reducer, defaultState);



// WEBPACK FOOTER //
// ./src/reducers/forms.js